import React, { useState } from "react";
import { Cron } from "react-js-cron";
import { useEffect } from "react";

import "react-js-cron/dist/styles.css";

type Props = {
  defaultValue?: string;
  value?: string;
  setValue?: (value: string) => any;
};

const locale = {
  everyText: "每",
  // emptyMonths?: string
  emptyMonthDays: "每日",
  emptyMonthDaysShort: "每日",
  emptyWeekDays: "每周几",
  emptyWeekDaysShort: "每周几",
  emptyHours: "每时",
  emptyMinutes: "每分",
  // emptyMinutesForHourPeriod?: strin,
  // yearOption?: strin,
  monthOption: "月",
  weekOption: "周",
  dayOption: "日",
  hourOption: "小时",
  minuteOption: "分钟",
  rebootOption: "重置",
  prefixPeriod: "每",
  prefixMonths: "在",
  prefixMonthDays: "在",
  prefixWeekDays: "在",
  // prefixWeekDaysForMonthAndYearPeriod?: strin,
  prefixHours: "在",
  prefixMinutes: "在",
  // prefixMinutesForHourPeriod?: strin,
  // suffixMinutesForHourPeriod?: strin,
  // errorInvalidCron?: strin,
  weekDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  // months?: string[,
  altWeekDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  // altMonths?: string[,
};

export default function CronInput(props: Props) {
  const { defaultValue, value, setValue } = props;

  const [innerValue, setInnerValue] = useState<string>(
    defaultValue || "* * * * 1"
  );

  useEffect(() => {
    setValue && setValue(innerValue);
  }, [innerValue]);
  useEffect(() => {
    value && setInnerValue(value);
  }, [value]);

  return (
    <Cron
      value={innerValue}
      setValue={setInnerValue}
      allowedPeriods={["month", "week", "day", "hour"]}
      mode="single"
      locale={locale}
    ></Cron>
  );
}
